var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('h3',[_vm._v("协议")]),_c('div',{staticClass:"know",domProps:{"innerHTML":_vm._s(_vm.urllist)}})])}
var staticRenderFns = []

export { render, staticRenderFns }